/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneControl from 'solis/logic/board/zone/control';

import TimelineEvent from 'solis/logic/board/zone/timeline/event';


export default class FlipEvent extends TimelineEvent
{
  constructor (zone)
  {
    super(zone);

    this.user = null;
  }


  findNextDate (startDate)
  {
    const control = new ZoneControl(this.zone);

    const winner = control.getCurrentUser();

    for (const entry of control.getUsers())
    {
      if (this.setEarlierDate(winner.getFlipDate(entry, startDate)))
      {
        this.user = entry.user;
      }
    }
  }


  apply ()
  {
    super.apply();

    new ZoneControl(this.zone).updateUser();
  }


  getLabel ()
  {
    return `zone flips to ${this.getUserName(this.user)}`;
  }


};
